import { secondsToHours, parseInternalDatetime } from '~/utils/time_utils';
import { SETTINGS_SMART_NOTIFICATIONS } from '~/app_constants';

export default {
  computed: {
    isTimeBasedMetric() {
      const timeBasedMetrics = [
        'work_time', 'time_spent_in_tool', 'unusual_activity', 'suspicious_activity', 'idle_time', 'manual_time'
      ];

      return timeBasedMetrics.includes(this.rule.metric_type);
    },
    isCountMetric() {
      return SETTINGS_SMART_NOTIFICATIONS.options.countMetrics.includes(this.rule.metric_type);
    },
    countMetricAddon() {
      switch (this.rule.metric_type) {
        case 'users_per_ip':
          return 'users';
        case 'geo_ip_list_match':
          return 'matches';
        default:
          return 'changes';
      }
    },
    ruleSubtitle() {
      const rule = this.rule;
      const metricType = this.computedMetricType || '';

      if (['unusual_activity', 'suspicious_activity'].includes(rule.metric_type)) {
        let name;

        if (rule.metric_type === 'suspicious_activity') {
          name = 'Suspicious applications';
        } else {
          name = 'Unusual activity';
        }

        return `${metricType} - ${name}`;
      }

      const condition = this.getConditionValue(rule.condition_value);
      const text = `- ${metricType} ${rule.condition} ${condition.value} ${condition.addon}`;

      return text;
    },
  },
  methods: {
    showFullDayLink(frequency) {
      return ['hourly', 'daily'].includes(frequency);
    },
    // geo-IP metrics link to the Audit Log report (filtered to the member and location
    // changes) rather than the activities/screenshots day view, mirroring the email CTA.
    auditLogUrl(userId) {
      const from = parseInternalDatetime(this.notification.from).format('YYYY-MM-DD');
      const to = parseInternalDatetime(this.notification.to).format('YYYY-MM-DD');
      // The report reads its date range from a single "from - to" string in f[date];
      // f[from]/f[to] are ignored and it falls back to the default (last 7 days).
      const params = new URLSearchParams({
        'f[member]': userId,
        'f[event_action]': 'Location changed',
        'f[date]': `${from} - ${to}`,
      });

      return `/reports/${this.organization.id}/team/audit_logs?${params.toString()}`;
    },
    trackAuditLogClick() {
      window.analytics?.track('SN view audit log');
    },
    getConditionValue(val) {
      let value, addon;
      const rule = this.rule;

      if (this.isTimeBasedMetric) {
        value = secondsToHours(val);

        if (rule.frequency === 'hourly') {
          addon = 'min/hr';
        } else if (rule.frequency === 'daily' || rule.time_unit === 'per_day') {
          addon = rule.frequency === 'daily' ? 'hr/day' : 'Avg. hr/day';
        } else if (rule.frequency === 'weekly' || rule.time_unit === 'per_week') {
          addon = 'hr/week';
        } else if (rule.frequency === 'monthly' || rule.time_unit === 'per_month') {
          addon = 'hr/month';
        } else {
          console.error(`Unexpected frequency and metric combination ${rule.frequency} ${rule.metric_type}`);
          addon = '';
        }
      } else if (this.isCountMetric) {
        // Count metrics (geo-IP changes, users sharing an IP, geo-IP list match) are not
        // percentages; show their own unit instead of "%".
        value = val;
        addon = this.countMetricAddon;
      } else {
        value = val;
        addon = '%';
      }

      return { addon, value };
    },
  },
};
